import { collection, addDoc } from "firebase/firestore";
import { db } from "@freetech/models/db";
import { ICreateClient } from "@freetech/models";
import { Client } from "@freetech/models/projects";

export const createClient = async (newClient: ICreateClient, currentUser: any) => {
  if (!currentUser) {
    throw new Error("User not found");
  }

  const clientData: ICreateClient = {
    ...newClient,
    companyName: newClient.companyName!,
    pointOfContactName: newClient.pointOfContactName!,
    email: newClient.email!,
    phone: newClient.phone!,
    location: newClient.location!,
    size: newClient.size!,
    status: newClient.status || "opportunity",
    introductionDate: newClient.introductionDate || new Date().toISOString(),
    createdByUserId: currentUser?.uid || "",
  };

  const clientsRef = db.clients;
  return await addDoc(clientsRef, clientData);
};
